import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { health, getGvcResults, getGavResumo } from "../api/client";

const CARDS = [
  { to: "/gdpb",    label: "GDPB",     desc: "Criar/atualizar produtos no Bling", icon: "🚀" },
  { to: "/gvc",     label: "GVC",      desc: "Auditar canais (ML, Shopee, Amazon)", icon: "🔍" },
  { to: "/modulos", label: "Módulos",  desc: "EPEG, GNFF e BIP", icon: "⚙️"  },
];

const STATUS_COLORS = {
  OK:     "bg-green-100 text-green-800",
  ERRO:   "bg-red-100 text-red-800",
  ALERTA: "bg-yellow-100 text-yellow-800",
};

export default function Dashboard() {
  const [apiUp, setApiUp]       = useState(null);
  const [results, setResults]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [gav, setGav]           = useState(null);

  useEffect(() => {
    health()
      .then(() => setApiUp(true))
      .catch(() => setApiUp(false));

    getGavResumo().then(({ data }) => setGav(data)).catch(() => setGav(null));

    getGvcResults(200)
      .then(({ data }) => setResults(data))
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Dashboard</h2>
        <div className="flex items-center gap-2 text-sm">
          <span
            className={`w-2.5 h-2.5 rounded-full ${
              apiUp === null ? "bg-gray-400" : apiUp ? "bg-green-500" : "bg-red-500"
            }`}
          />
          <span className="text-gray-600">
            API {apiUp === null ? "verificando..." : apiUp ? "online" : "offline"}
          </span>
        </div>
      </div>

      {gav?.feedbacks_nao_vistos > 0 && (
        <Link to="/gav" className="block mb-4 bg-red-50 border border-red-200 text-red-800 text-sm rounded-lg px-4 py-3 hover:bg-red-100">
          ⭐ {gav.feedbacks_nao_vistos} feedback(s) negativo/neutro novo(s) na Amazon — ver em Avaliações Amazon
        </Link>
      )}

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        {CARDS.map(({ to, label, desc, icon }) => (
          <Link
            key={to}
            to={to}
            className="bg-white rounded-xl shadow p-5 hover:shadow-md hover:-translate-y-0.5 transition-all"
          >
            <div className="text-3xl mb-2">{icon}</div>
            <div className="font-bold text-blue-900">{label}</div>
            <div className="text-gray-500 text-sm mt-1">{desc}</div>
          </Link>
        ))}
      </div>

      {/* Últimos resultados GVC */}
      <div className="bg-white rounded-xl shadow p-5">
        <h3 className="font-bold text-gray-800 mb-4">
          Última execução do GVC
          {results.length > 0 && (
            <span className="ml-2 text-gray-400 font-normal text-sm">
              ({results.length} registros)
            </span>
          )}
        </h3>

        {loading ? (
          <p className="text-gray-400 text-sm">Carregando...</p>
        ) : results.length === 0 ? (
          <p className="text-gray-400 text-sm">
            Nenhum resultado — execute o GVC para ver os dados aqui.
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-500 border-b">
                  <th className="pb-2 pr-4">SKU</th>
                  <th className="pb-2 pr-4">Canal</th>
                  <th className="pb-2 pr-4">Divergência</th>
                  <th className="pb-2">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {results.map((r, i) => (
                  <tr key={i}>
                    <td className="py-2 pr-4 font-mono text-xs text-gray-700">{r.sku}</td>
                    <td className="py-2 pr-4 text-gray-600">{r.canal}</td>
                    <td className="py-2 pr-4 text-gray-600 max-w-xs truncate">{r.divergencia}</td>
                    <td className="py-2">
                      <span
                        className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                          STATUS_COLORS[r.status] || "bg-gray-100 text-gray-700"
                        }`}
                      >
                        {r.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
